import { render, staticRenderFns } from "./recordList.vue?vue&type=template&id=548d13ba&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"
import style0 from "./recordList.vue?vue&type=style&index=0&id=548d13ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548d13ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('548d13ba')) {
      api.createRecord('548d13ba', component.options)
    } else {
      api.reload('548d13ba', component.options)
    }
    module.hot.accept("./recordList.vue?vue&type=template&id=548d13ba&scoped=true", function () {
      api.rerender('548d13ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/surety/recordList.vue"
export default component.exports